import { createReducer } from '@reduxjs/toolkit';
import { deleteCard } from '../../actions/deleteCard';
import { deletePrimaryCard } from '../../actions/deletePrimaryCard';
import { fetchCards } from '../../actions/fetchCards';
import { fetchDemoCards } from '../../actions/fetchDemoCards';
import { markCardPrimary } from '../../actions/markCardPrimary';
import { ICard } from '../../types/Card';

const initialState: ICard[] = [];

export const sortCardsByPrimary = (cards: ICard[]): ICard[] => cards.slice().sort((card) => (card.primary ? -1 : 1));

export const cardsReducer = createReducer<ICard[]>(initialState, (builder) =>
  builder
    .addCase(fetchCards.fulfilled, (state, action) => sortCardsByPrimary(action.payload))
    .addCase(deletePrimaryCard.fulfilled, (state, action) => sortCardsByPrimary(action.payload))
    .addCase(deleteCard.fulfilled, (state, action) => state.filter((card) => card.creditCardId !== action.meta.arg))
    .addCase(markCardPrimary.fulfilled, (state, action) =>
      state.map((card) => ({
        ...card,
        primary: card.creditCardId === action.meta.arg,
      })),
    ),
);

export const demoCardsReducer = createReducer<ICard[]>([], (builder) =>
  builder.addCase(fetchDemoCards.fulfilled, (state, action) => sortCardsByPrimary(action.payload.demoCards)),
);
